import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { initErrorHandler } from '../actions';
import { IEnvironment } from '../../../environments/environment.interface';

@Injectable()
export class AppDispatcher {
  constructor(private _store: Store<any>) {}

  initErrorHandler(environment: IEnvironment) {
    this._store.dispatch(initErrorHandler(environment));
  }
}
